import { COOKIE_EXPIRY_AUTH_FORM } from '@/constants/cookie.constants';
import { flattenQueryParam } from '@/general/helpers/flattenQueryParam';
import { SearchParams } from '@/types/Nextjs.type';
import { pushToDataLayer } from '@/utils/pushToDataLayer';

export const getAuthFormCookieExpiry = (isSubmitted?: boolean) =>
  new Date(
    new Date().getTime() +
      (isSubmitted
        ? 10000 // 10 sec in ms
        : COOKIE_EXPIRY_AUTH_FORM),
  );

export const onSubmitSuccessTracking = (step: string) =>
  pushToDataLayer({
    event: `authentication_step-${step}`,
    success: true,
  });

/**
 * Safely gets and flattens a query parameter from searchParams.
 */
export const getFlatQueryParam = (searchParams: SearchParams, paramName: string): string | undefined => {
  const param = searchParams[paramName];
  return param ? flattenQueryParam(param) : undefined;
};
